import React from 'react';

type IconProps = {
  inverse?: boolean;
  children?: React.ReactNode;
  onClick: React.MouseEventHandler<HTMLElement>;
  classNameIconType?: string;
  className?: string;
}

const Icon = (props: IconProps) => {
  const {
    inverse,
    children,
    onClick,
    classNameIconType,
    className = '',
  } = props;

  const classNameInverse = inverse ? 'fill-white' : '';
  const classNameClickable = onClick ? 'cursor-pointer' : '';
  const classNameIcon = `c-icon flex items-center justify-center ${classNameIconType ?? ''} ${classNameInverse} ${classNameClickable}`;

  const handleClick = (event) => {
    if (typeof onClick === 'function') {
      return onClick(event);
    }
    return null;
  };

  return (
    <span
      className={`${classNameIcon} ${className}`}
      onClick={handleClick}
      role='img'
    >
      {children}
    </span>
  );
};

export default Icon;
